import ReactDOM from "react-dom";

import "./admin-reservation.scss";
import "./reservation.scss";
import { useCallback, useEffect } from "react";
import $ from "jquery";

import { ReserveLists, ToursTab } from "./Tabs";
import { EditModals, SignupUserModal } from "./Modals";

import { ReservationContextProvider } from "./ReservationContext";
import { ModalContextProvider } from "./ModalContext";

export default function Index() {
  return (
    <ReservationContextProvider>
      <ModalContextProvider>
        <div className="admin-reservation-container px-sm-3 w-100">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#active-tour-list"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                لیست رزرو تورهای فعال
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#tour-list-history"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                سابقه
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id=""
                data-bs-toggle="tab"
                data-bs-target="#tours-tab"
                type="button"
              >
                تور ها
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <ReserveLists />
            <ToursTab />
          </div>
          {ReactDOM.createPortal(
            <>
              <EditModals />
              <SignupUserModal />,
            </>,
            document.querySelector(".modals")
          )}
        </div>
      </ModalContextProvider>
    </ReservationContextProvider>
  );
}
